// Logo.js
function Logo({ className = "" }) {
  return (
    <div className={`logo ${className}`}>
      <span className="logo-white">CODE</span>
      <span className="logo-yellow">ION</span>
    </div>
  );
}

export default Logo;